export const DATA_HOOKS = {
  groupList: 'group-list',
  groupNameInput: 'group-name',
  groupCreateButton: 'create-button',
  createGroupModal: 'create-group-modal',
  createNewButton: 'create-new-button',
  pendingGroupList: 'pending-group-list',
  groupListTitle: 'group-list-title',
};
